/**
 *  @fileOverview Modal module, initalises image modal instances, uses https://micromodal.now.sh/
 *
 *  @author       Chris Hill
 *
 */

function ModalModule (Micromodal) {
  /**
   * @description Initialises modal instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Get all links
     */
    var links = document.querySelectorAll('.modalTrigger__image')

    /**
     * Only run if links are present on page
     */
    if (links.length > 0) {
      /**
       * Loop through and add click events
       */
      links.forEach((link, index) => {
        let src = ''
        let caption = ''
        let iframe = false
        const screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        const screenheight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        const alt = link.getAttribute('alt')
        let width = parseInt((screenwidth / 100) * 80)
        let height = parseInt((screenheight / 100) * 80)

        /**
         * Check for src
         */
        if (typeof link.dataset.src !== 'undefined') {
          src = link.dataset.src
        }

        /**
         * Check for caption
         */
        if (typeof link.dataset.caption !== 'undefined') {
          caption = link.dataset.caption
        }

        /**
         * Check for iframe
         */
        if (typeof link.dataset.iframe !== 'undefined') {
          iframe = true
        }

        /**
         * Check for width
         */
        if (typeof link.dataset.width !== 'undefined') {
          width = link.dataset.width
        }

        /**
         * Check for height
         */
        if (typeof link.dataset.height !== 'undefined') {
          height = link.dataset.height
        }

        /**
         * Only create modal if there is src to load
         */
        if (src !== '') {
          link.addEventListener('click', function (e) {
            e.preventDefault()

            /**
             * Do modal if not iframe on a small screen
             */
            if (!iframe || screenwidth > 768) {
              /**
               * Create modal object
               */
              let modal = document.createElement('div')
              modal.id = 'popup'
              modal.className = 'modal'
              modal.setAttribute('aria-modal', true)
              modal.setAttribute('aria-hidden', true)

              /**
               * Append modal to body
               */
              document.querySelector('body').appendChild(modal)

              let body = ''
              if (iframe) {
                body = `
                    <iframe src="${src}" width="${width}" height="${height}"></iframe>
                    ${caption !== '' ? `<div id="modal__caption" class="modal__caption">${caption}</div>` : ''}
                  `
              } else {
                body = `
                    <img src="${src}" alt="${alt}" />
                    ${caption !== '' ? `<div id="modal__caption" class="modal__caption">${caption}</div>` : ''}
                  `
              }

              modal.innerHTML = `
                <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                  <div class="modal__container modal__container--image" role="dialog" aria-modal="true" aria-labelledby="modal__caption">
                    <main class="modal__body">
                      ${body}
                    </main>
                    <button class="modal__close" aria-label="Close modal" data-micromodal-close>
                      <i title="close modal" class="fas fa-times fa-2x"></i>
                    </button>
                  </div>
                </div>`

              /**
               * Initialise Micromodal, remove modal div on close
               */
              Micromodal.show('popup', {
                // onShow: modal => console.info(`${modal.id} is shown`), // [1]
                onClose: modal => modal.parentNode.removeChild(modal)
              })

              let closebtn = document.querySelector('.modal__close')

              closebtn.addEventListener('click', function (e) {
                e.preventDefault()

                Micromodal.close('popup')
                closebtn.removeEventListener('click', function (e) {})
              })
            } else {
              window.open(src, 'popup')
            }
          })
        }
      })
    }
  }
}

module.exports = ModalModule
